import styled from "styled-components";
import Space from "../../../../Space";
import { BoxBaseProps } from "../../BoxBase.types";
import { ColorPaletteOptions } from "../../../../../../types/theming";
import cssObjectForActiveScrollbar from "./functions/cssObjectForActiveScrollbar";
import cssObjectForScrollbarPart from "./functions/cssObjectToScrollbarPart";
import { ColorHex } from "../../../../../../types/globals";

export const SCROLL_ZONE_VALUE = 20;
const SCROLL_ZONE = `${SCROLL_ZONE_VALUE}px`;

type StyledScrollableContainerProps = BoxBaseProps<ColorPaletteOptions> & {
	isFirefox?: boolean;
};

/* overflow needs passing in here */
export const StyledScrollableContainer = styled(
	Space
)<StyledScrollableContainerProps>`
	position: relative;
	> .Box {
		overflow: unset;
	}

	${({ theme, ...props }) => {
		return {
			backgroundColor:
				theme.palette.hexFor(props.backgroundColor) || "transparent",
			borderRadius: props.borderRadius ? theme.radii[props.borderRadius] : 0,
			...(props.borderTopLeftRadius && {
				borderTopLeftRadius: theme.radii[props.borderTopLeftRadius],
			}),
			...(props.borderTopRightRadius && {
				borderTopRightRadius: theme.radii[props.borderTopRightRadius],
			}),
			...(props.borderBottomLeftRadius && {
				borderBottomLeftRadius: theme.radii[props.borderBottomLeftRadius],
			}),
			...(props.borderBottomRightRadius && {
				borderBottomRightRadius: theme.radii[props.borderBottomRightRadius],
			}),
		};
	}}

	${({ theme, ...props }) => {
		const COLOR_TRACK = theme.palette.hexForRole("bg_light") as ColorHex;
		const COLOR_THUMB = theme.palette.hexForRole("cta_default") as ColorHex;

		if (props.isFirefox) {
			return {
				scrollbarColor: `${COLOR_THUMB} ${COLOR_TRACK}`,
				scrollbarWidth: "thin",
			};
		}

		return {
			"::-webkit-scrollbar": {
				width: SCROLL_ZONE,
				height: SCROLL_ZONE,
				borderRadius: theme.radii.md,
			},

			"::-webkit-scrollbar-corner": {
				backgroundColor: "transparent",
			},

			"::-webkit-scrollbar-track": cssObjectForScrollbarPart(
				COLOR_TRACK,
				theme.radii.md
			),
			"::-webkit-scrollbar-thumb": cssObjectForScrollbarPart(
				COLOR_THUMB,
				theme.radii.md
			),

			"&.ScrollableContainer--active-h":
				cssObjectForActiveScrollbar("horizontal"),
			"&.ScrollableContainer--active-v":
				cssObjectForActiveScrollbar("vertical"),
		};
	}}
`;
